// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var MenuItemLinkVue2 = {
  name: 'KendoMenuItemLink',
  props: {
    opened: Boolean,
    focused: Boolean,
    url: String
  },
  computed: {
    menuItemClassName: function menuItemClassName() {
      return {
        'k-link': true,
        'k-menu-link': true,
        'k-active': this.$props.opened,
        'k-focus': this.$props.focused
      };
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    if (this.$props.url) {
      return h("a", {
        "class": this.menuItemClassName,
        role: "presentation",
        attrs: this.v3 ? undefined : {
          role: "presentation",
          href: this.$props.url,
          tabindex: -1
        },
        href: this.$props.url,
        tabindex: -1
      }, [defaultSlot]);
    } else {
      return h("span", {
        "class": this.menuItemClassName,
        role: "presentation",
        attrs: this.v3 ? undefined : {
          role: "presentation"
        }
      }, [defaultSlot]);
    }
  }
};
/**
 * @hidden
 */
var MenuItemLink = MenuItemLinkVue2;
export { MenuItemLink, MenuItemLinkVue2 };